// extracted by mini-css-extract-plugin
export default {"responsiveBackground":"auoZZA"};